// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3xOfu","item":"PaymentsMobile_item__1PTt6","label":"PaymentsMobile_label__tROyH","amount":"PaymentsMobile_amount__1Tk0A"};